import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useOperationsService, DeploymentMap } from '../services/operationsService';
import { kernelKeys } from './queryKeys';

export function useDeploymentMap() {
  const service = useOperationsService();

  const query = useQuery({
    queryKey: kernelKeys.deploymentMap(),
    queryFn: () => service.getDeploymentMap(),
  });

  const { refetch } = query;
  const refresh = useCallback(() => {
    refetch();
  }, [refetch]);

  return {
    data: (query.data ?? null) as DeploymentMap | null,
    loading: query.isFetching,
    error: query.error
      ? query.error instanceof Error
        ? query.error.message
        : 'Failed to load deployment map'
      : null,
    refresh,
  };
}
